/**
 * @module app.OlcsControl
 */
import {pickBottomPoint, computeSignedTiltAngleOnGlobe, rotateAroundAxis, setHeadingUsingBottomCenter, computeAngleToZenith} from 'ol-cesium/src/olcs/core.ts';

/**
 * Almost PI / 2.
 * @const
 * @type {number}
 */
export const MAX_TILT = 7 * Math.PI / 16;


/**
 * @const
 * @type {number}
 */
export const MIN_TILT = 0;

/**
 * @param {!olcs.OLCesium} ol3d
 * @constructor
 */
export default class OlcsControl {
  constructor(ol3d) {

    /**
    * @type {!olcs.OLCesium}
    * @private
    */
    this.ol3d_ = ol3d;
  }

  /**
  * @return {ol.View}
  */
  getOlView() {
    return this.ol3d_.getOlMap().getView();
  }

  /**
  * @return {Array.<number>}
  */
  getTiltRange() {
    return [MIN_TILT, MAX_TILT];
  }

  /**
  * @return {number}
  */
  getHeading() {
    const scene = this.ol3d_.getCesiumScene();
    const camera = scene.camera;
    return -camera.heading;
  }

  /**
  * @return {number|undefined}
  */
  getTiltOnGlobe() {
    const scene = this.ol3d_.getCesiumScene();
    const tiltOnGlobe = computeSignedTiltAngleOnGlobe(scene);
    return -tiltOnGlobe;
  }

  /**
  * @param {function()} callback
  */
  resetToNorthZenith(callback) {
    const scene = this.ol3d_.getCesiumScene();
    const camera = scene.camera;
    const pivot = pickBottomPoint(scene);

    if (!pivot) {
      callback();
      return;
    }

    const angle = computeAngleToZenith(scene, pivot);

    // Point to North
    setHeadingUsingBottomCenter(scene, 0, pivot);

    // Go to zenith
    const transform = Cesium.Matrix4.fromTranslation(pivot);
    const axis = camera.right;
    const options = {callback: callback};
    rotateAroundAxis(camera, -angle, axis, transform, options);
  }

  /**
  * @param {number} angle
  */
  setHeading(angle) {
    const scene = this.ol3d_.getCesiumScene();
    const bottom = pickBottomPoint(scene);
    if (bottom) {
      setHeadingUsingBottomCenter(scene, angle, bottom);
    }
  }

  /**
  * @param {number} angle
  */
  tiltOnGlobe(angle) {
    const scene = this.ol3d_.getCesiumScene();
    const camera = scene.camera;
    const pivot = pickBottomPoint(scene);
    if (!pivot) {
      // Could not find the bottom point
      return;
    }

    const options = {};
    const transform = Cesium.Matrix4.fromTranslation(pivot);
    const axis = camera.right;
    rotateAroundAxis(camera, -angle, axis, transform, options);

  }
}
